var _style, _polygon, _g, _circle, _circle2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4517.4 1280.8",
    style: {
      enableBackground: "new 0 0 4517.4 1280.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#353535;}\n\t.st2{enable-background:new    ;}\n\t.st3{fill:#F1A58E;}\n\t.st4{fill:#652150;}\n\t.st5{clip-path:url(#SVGID_00000160880261241547427300000003550747464073374859_);fill:#89385D;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "5895.5,1572.8 5902.3,1572.8 5902.3,1572.8 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3199.8,
    y: 269.4,
    className: "st1",
    width: 209.8,
    height: 40.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3535.7,
    y: 269.4,
    className: "st1",
    width: 209.8,
    height: 40.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 941.5,
    y: 269.8,
    className: "st0",
    width: 4499.6,
    height: 1436.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1336,973.3h-262.5v-21h52.5v-441h-63v-21h63c0-154,69.3-231,207.9-231c49,0,86.4,10.3,112.3,31 s38.8,44.6,38.8,71.9c0,16.8-5.4,29.9-16.3,39.4s-23.6,14.2-38.3,14.2c-37.8,0-56.7-22.6-56.7-67.7c0-45.2-13.3-67.7-39.9-67.7 c-19.6,0-32.9,17-39.9,50.9c-7,34-10.5,87-10.5,159.1H1420v21h-136.5v441h52.5V973.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1921.2,762.3h-317.1c7,123.2,54.9,184.8,143.8,184.8c23.8,0,50.9-5.6,81.4-16.8 c30.5-11.2,52.7-26.9,66.7-47.2l14.7,10.5c-15.4,25.9-41.7,47.2-78.8,64s-74,25.2-110.8,25.2s-69.8-3.7-99.2-11 c-29.4-7.3-58.1-19.8-86.1-37.3s-49.9-43.8-65.6-78.8s-23.6-77.3-23.6-127c0-84.7,23.4-147.5,70.3-188.5 c46.9-40.9,103.8-61.4,170.6-61.4s122.5,22.4,167,67.2C1899,590.8,1921.2,662.9,1921.2,762.3z M1603.1,741.3h171.1 c0-64.4-6.8-120.7-20.5-169s-35.5-72.5-65.6-72.5s-51.8,23.3-65.1,69.8c-13.3,46.6-19.9,99.9-19.9,160.1V741.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2240.4,973.3h-262.5v-21h52.5v-441h-52.5v-21h210v125c6.3-34.3,17.7-62.3,34.1-84 c16.4-21.7,34.6-36,54.6-43s39.2-10.5,57.7-10.5s36.4,3.3,53.5,10c17.2,6.7,29.9,20,38.3,39.9s8.8,39.9,1,59.8 c-7.7,20-21.2,34.1-40.4,42.5s-36.9,9.5-53,3.1c-16.1-6.3-27.6-14.9-34.6-25.7s-11.9-21.2-14.7-31c-7-25.9-16.5-38.8-28.3-38.8 c-13.3,0-28,22.9-44.1,68.8s-24.1,94.3-24.1,145.4v200.5h52.5V973.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2678.2,511.3v256.2c0,60.2,2.4,96.8,7.3,109.7c4.9,13,10.2,24,15.8,33.1c10.5,18.2,28.9,27.3,55.1,27.3 s44.6-3.5,55.1-10.5v21c-33.6,23.8-70.3,35.7-110.2,35.7c-58.8,0-103.6-14-134.4-42s-46.2-78-46.2-150.2V511.3H2443v-21h77.7 c33.6-5.6,63.3-21.9,89.2-48.8s43.8-64.2,53.6-111.8h14.7v160.7H2800v21L2678.2,511.3L2678.2,511.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3074,952.3h52.5v21H2864v-21h52.5v-441h-42v-21H3074V952.3z M3083.5,351.2c0,25.6-8.9,47.3-26.8,65.1 s-39.5,26.8-65.1,26.8s-47.4-8.9-65.6-26.8c-18.2-17.8-27.3-39.5-27.3-65.1c0-25.5,9.1-47.4,27.3-65.6 c18.2-18.2,40.1-27.3,65.6-27.3s47.2,9.1,65.1,27.3C3074.6,303.8,3083.5,325.6,3083.5,351.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3410,951.3h52.5v21H3200v-21h52.5V289.8H3200v-21h210V951.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3746,951.3h52.5v21H3536v-21h52.5V289.8H3536v-21h210V951.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4024.8,1177.5c-21,17.8-49,26.8-84,26.8s-62.3-7.5-81.9-22.6c-19.6-15.1-29.4-35-29.4-59.8 c0-24.9,7.2-44.6,21.5-59.3c14.3-14.7,31.7-22,52-22s37.5,3.8,51.5,11.5s23.8,16.1,29.4,25.2c15.4,24.5,29.9,36.8,43.6,36.8 c13.6,0,25.7-11.9,36.2-35.7l44.1-104l-245.7-463h-42v-21h282.5v21H4050l140.7,277.2l120.8-277.2h-84v-21h172.2v21h-63 l-252,578.5C4065.7,1130.4,4045.8,1159.7,4024.8,1177.5z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1072.9,
    y: 933.2,
    className: "st1",
    width: 263.9,
    height: 40.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1540.5,
    y: 721.7,
    className: "st1",
    width: 263.9,
    height: 40.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1977.5,
    y: 933.2,
    className: "st1",
    width: 263.9,
    height: 40.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1977.5,
    y: 489.9,
    className: "st1",
    width: 210.4,
    height: 40.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2864.1,
    y: 933.2,
    className: "st1",
    width: 263.9,
    height: 40.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2442.7,
    y: 489.9,
    className: "st1",
    width: 357,
    height: 40.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2874.6,
    y: 490.9,
    className: "st1",
    width: 199.5,
    height: 40.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3199.3,
    y: 933.2,
    className: "st1",
    width: 263.9,
    height: 40.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3535.1,
    y: 933.2,
    className: "st1",
    width: 263.9,
    height: 40.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3819.6,
    y: 489.9,
    className: "st1",
    width: 283.8,
    height: 40.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4227.4,
    y: 489.9,
    className: "st1",
    width: 172.2,
    height: 40.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3845.7,
    y: 796.3,
    transform: "matrix(0.4058 -0.914 0.914 0.4058 1737.3466 4305.4785)",
    className: "st1",
    width: 668.3,
    height: 40.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1063,
    y: 489.9,
    className: "st1",
    width: 357,
    height: 40.7
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 422.8,
    cy: 741.2,
    r: 282.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 563.1,
    cy: 509.2,
    r: 284.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 563.1,
    cy: 509.2,
    r: 284.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000094606597280256097300000003581370809448245658_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000094606597280256097300000003581370809448245658_)",
      fill: "#89385D"
    },
    cx: 422.8,
    cy: 741.2,
    r: 282.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.35da06e282b43b52b821224f079541d5.svg";
export { ForwardRef as ReactComponent };